// extracted by mini-css-extract-plugin
export default {"root":"RadioButtonGroup_root__-KwLN","card":"RadioButtonGroup_card__rOkLI","label":"RadioButtonGroup_label__SGVT-"};